/**
 * Pure image/pixel manipulation functions.
 *
 * Extracted from TileCompositeService so they can be tested in isolation
 * and reused by other image-related modules.
 */

/** Minimal interface matching the browser ImageData shape. */
export interface PixelData {
  readonly data: Uint8ClampedArray
  readonly width: number
  readonly height: number
}

/**
 * Apply a cloud mask to imagery. Where the mask has alpha > 0 (cloud detected),
 * set the imagery pixel to fully transparent. Returns a new object with a
 * cloned pixel buffer — the original imagery is never mutated.
 *
 * If the mask dimensions don't match the imagery, the imagery is returned
 * unchanged (copy only, no masking applied).
 */
export function applyCloudMask(imagery: PixelData, mask: PixelData): PixelData {
  const cloned = new Uint8ClampedArray(imagery.data)

  if (imagery.width === mask.width && imagery.height === mask.height) {
    const maskData = mask.data
    for (let i = 0; i < cloned.length; i += 4) {
      if (maskData[i + 3] > 0) {
        // Cloud pixel — make transparent
        cloned[i + 3] = 0
      }
    }
  }

  return { data: cloned, width: imagery.width, height: imagery.height }
}
